import { schema } from 'normalizr';

export const page = new schema.Entity('pages');
export const pageList = new schema.Array(page);

export const property = new schema.Entity('properties', {
  pages: [page],
});
export const propertyList = new schema.Array(property);

export const category = new schema.Entity('categories');
export const categoryList = new schema.Array(category);

export const integration = new schema.Entity('integrations', {}, { idAttribute: 'type' });
export const integrationList = new schema.Array(integration);

export const user = new schema.Entity('users');
export const userList = new schema.Array(user);

export const product = new schema.Entity('products');
export const productList = new schema.Array(product);

export const spaTreatment = new schema.Entity('spaTreatments');
export const spaTreatmentsList = new schema.Array(spaTreatment);

export const facility = new schema.Entity('facilities');
export const facilitiesList = new schema.Array(facility);

export const spaDay = new schema.Entity('spaDays');
export const spaDaysList = new schema.Array(spaDay);

export const spaPackage = new schema.Entity('spaPackages');
export const spaPackages = new schema.Array(spaPackage);
export const spaPackagesList = new schema.Array(spaPackage);

export const spaPackageAllEntity = new schema.Entity('spaPackagesAll');
export const spaPackagesAll = new schema.Array(spaPackageAllEntity);
export const spaPackagesAllList = new schema.Array(spaPackageAllEntity);

export const homepage = new schema.Entity('homepages', {
  featuredProducts: [product],
  otherProducts: [product],
  categories: [category],
});

export const abstract = new schema.Entity('abstracts');
export const abstractList = new schema.Array(abstract);

export const spaClassTimeslot = new schema.Entity(
  'spaClassesTimeslots',
  {},
  {
    idAttribute: (timeSlot, spaClass) => `${spaClass.id}-${timeSlot.startDateTime}`,
    processStrategy: (timeSlot, spaClass) => ({
      ...timeSlot,
      classId: spaClass.id,
    }),
  }
);

export const spaClassTimeslotList = new schema.Array(spaClassTimeslot);

export const spaClass = new schema.Entity('spaClasses', {
  availability: [spaClassTimeslot],
});

export const spaClassList = new schema.Array(spaClass);

export const packaging = new schema.Entity('packagings');
export const packagingList = new schema.Array(packaging);

export const option = new schema.Entity('options');
export const optionList = new schema.Array(option);

export const postage = new schema.Entity('postages');
export const postageList = new schema.Array(postage);

export const schemaMap = {
  homepages: homepage,
  pages: page,
};
